import WebSocketClient from './wsClient.js'


// Irrigate a pot
export async function ws_pot_irrigate(hubSN, potSN) {
    WebSocketClient.sendMessage('startManualIrrigate_app|'+String(hubSN)+'|'+String(potSN));
}

// Stop irrigation for a pot
export async function ws_pot_irrigate_stop(hubSN, potSN) {
    WebSocketClient.sendMessage('stopManualIrrigate_app|'+String(hubSN)+'|'+String(potSN));
}


export async function ws_calibrateIrrigationTime(hubSN, potSN, irrigationTime) {
    WebSocketClient.sendMessage('irrCalibration_app|' + String(hubSN) + '|' + String(potSN) + '|' + String(irrigationTime));
}


export async function ws_updatePot(potSN) {
    WebSocketClient.sendMessage('updatePOT_app|' + String(potSN));
}


export async function ws_unassignPot(hubSN, potSN) {
    WebSocketClient.sendMessage('unassingPOT_app|' + String(hubSN) + '|' + String(potSN));
}


export async function ws_scaleCalibration(hubSN, waterLevel) {
    WebSocketClient.sendMessage('scaleCalibration_app|' + String(hubSN) + '|' + String(waterLevel));
}


export async function ws_resetScaleCalibration(hubSN) {
    WebSocketClient.sendMessage('resetScaleCalibration_app|' + String(hubSN));
}